<div class="container-fluid mt-3">
    <!-- 共有: オークション日 (全タブ共通) + 選択中の顧客 -->
    <div class="form-inline mb-2">
        <label class="mr-2"><strong>{{ 'kobeac.auction_date' | transloco }}</strong></label>
        <select class="form-control mr-3" [(ngModel)]="selectedAuctionRid" (ngModelChange)="onAuctionChange()">
            <option *ngFor="let a of auctions" [value]="a['@rid']">{{ auctionLabel(a) }}</option>
        </select>
        <span *ngIf="selectedCustomerName" class="text-muted">{{ 'kobeac.customer_label' | transloco: {name: selectedCustomerName} }}</span>
    </div>

    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link" [class.active]="tab === 'summary'" href="javascript:void(0)" (click)="select('summary')">{{ 'kobeac.statement' | transloco }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="tab === 'list'" href="javascript:void(0)" (click)="select('list')">{{ 'kobeac.ledger_list' | transloco }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="tab === 'invoice'" href="javascript:void(0)" (click)="select('invoice')">{{ 'kobeac.invoice_edit' | transloco }}</a>
        </li>
    </ul>
    <div class="tab-content mt-2">
        <div [hidden]="tab !== 'summary'">
            <kobeac-summary *ngIf="visited.summary" [embedded]="true" [auctionRid]="selectedAuctionRid"
                            (customerSelected)="onCustomerSelected($event)"></kobeac-summary>
        </div>
        <div [hidden]="tab !== 'list'">
            <kobeac-ledger-list *ngIf="visited.list" [embedded]="true" [auctionRid]="selectedAuctionRid"></kobeac-ledger-list>
        </div>
        <div [hidden]="tab !== 'invoice'">
            <kobeac-invoice-edit *ngIf="visited.invoice" [embedded]="true" [auctionRid]="selectedAuctionRid"
                                 [customerRid]="selectedCustomerRid"></kobeac-invoice-edit>
        </div>
    </div>
</div>
